import { IACDLEvent } from '../../../services/eventBus.service';

export const UserRemovedFromProjectType = Symbol('USER_REMOVED_FROM_PROJECT');

export class UserRemovedFromProject implements IACDLEvent {
  get type(): symbol {
    return UserRemovedFromProjectType;
  }
}
